export enum TerminologyGroupEnum {
    procedimentos = 10,
    medicamentos = 9,
    materiaisOPME = 8,
    dailyFeesMedicinalGases = 7,
}